<template>
	<RunningProgramsAdmin kind="hyrox" />
</template>

<script>
import RunningProgramsAdmin from './RunningProgramsAdmin.vue'

export default {
	name: 'GestioneSchedeHyroxAdmin',
	components: { RunningProgramsAdmin }
}
</script>
